import React from "react";
import InfoIcon from "@mui/icons-material/Info";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import styles from "./AlertTooltip.module.css";

const headingAndTooltips = [
  {
    tooltip: "No. of accepted Alerts / total No. of alerts",
    heading: "Actioned Alerts",
    itemKey: "Actioned Alerts",
  },
  {
    tooltip: "No. of closed Alerts / total No. of alerts",
    heading: "Material Impacted",
    itemKey: "Material Impacted",
  },
  {
    tooltip: "No. of bottleneck RMPM / Total Materials",
    heading: "Bottleneck Material",
    itemKey: "Bottleneck Material",
  },
];

const headingAndTooltipsMD = [
  {
    tooltip: "No. of accepted Alerts / total No. of alerts",
    heading: "Actioned Alerts",
    itemKey: "Actioned Alerts",
  },
  {
    tooltip: "Total CBUs for which alerts are raised",
    heading: "CBUs Impacted",
    itemKey: "CBUs Impacted",
  },
  {
    tooltip: "No. of high priority CBUs",
    heading: "High Priority CBUs",
    itemKey: "High Priority CBUs",
  },
];

const AlertTooltip = ({ name, type, kpi }) => {
  const headings = type === "md" ? headingAndTooltipsMD : headingAndTooltips;

  return (
    <Box className={styles.tooltipWrapper}>
      <Typography className={styles.siteName} variant="subtitle2">{name}</Typography>
      {typeof kpi === "number" ? 
        <div className={styles.internalAlert}>{kpi}</div>
       : 
      headings.map((item, index) => (
        <Box className={styles.row} key={index}>
          <Box className={styles.labelWrapper}>
            <Typography variant="body2" className={styles.label}>
              {item.heading}
            </Typography>
            <Tooltip
              title={
                <div
                  style={{
                    color: "black",
                  }}
                >
                  {item.tooltip}
                </div>
              }
              placement="top"
            >
              <InfoIcon className={styles.infoIcon} fontSize="inherit" />
            </Tooltip>
          </Box>
          <Typography variant="body2" className={styles.value}>
            {kpi[item.itemKey] ?? "-"}
          </Typography>
        </Box>
      ))
      }
    </Box>
  );
};

export default AlertTooltip;
